import React from "react";

export default function PromoDashboard() {
  return <div>PromoPage</div>;
}
